var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _a, _AnchorLinkUtils_pointsSomewhere, _AnchorLinkUtils_isPageLocalLink;
class AnchorLinkUtils {
    //
    // Returns an array of dom element links (a-tags) that
    // point to an existing element on this page.
    //
    // Anchor-links to other pages are excluded.
    //
    static findValidLinksOnThisPage() {
        const result = [];
        for (const a of document.querySelectorAll('a[href*="#"]')) {
            const atag = a;
            if (!__classPrivateFieldGet(_a, _a, "m", _AnchorLinkUtils_pointsSomewhere).call(_a, atag)) {
                continue;
            }
            if (!__classPrivateFieldGet(_a, _a, "m", _AnchorLinkUtils_isPageLocalLink).call(_a, atag)) {
                continue;
            }
            const hashValue = atag.hash.substring(1); // '#peng' -> 'peng'
            const targetDoesExist = document.getElementById(hashValue) !== null;
            if (!targetDoesExist) {
                continue;
            }
            result.push(a);
        }
        return result;
    }
}
_a = AnchorLinkUtils, _AnchorLinkUtils_pointsSomewhere = function _AnchorLinkUtils_pointsSomewhere(a) {
    return a.hash.length > 1; // exlucde target-free <a href='#'>Peng</a>
}, _AnchorLinkUtils_isPageLocalLink = function _AnchorLinkUtils_isPageLocalLink(a) {
    if (a.host !== window.location.host) {
        // anchor link to some other host
        return false;
    }
    if (a.port !== window.location.port) {
        return false;
    }
    if (a.protocol !== window.location.protocol) {
        return false;
    }
    if (a.pathname !== window.location.pathname) {
        // other document / url on same host,
        // pathname is set even if not part of href-attribute
        return false;
    }
    if (a.search !== window.location.search) {
        // different query string might not yield the same page content
        return false;
    }
    return true;
};
export default AnchorLinkUtils;
